import { render, staticRenderFns } from "./message-header.vue?vue&type=template&id=69f87e5a&scoped=true"
import script from "./message-header.vue?vue&type=script&lang=js"
export * from "./message-header.vue?vue&type=script&lang=js"
import style0 from "./message-header.vue?vue&type=style&index=0&id=69f87e5a&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69f87e5a",
  null
  
)

export default component.exports